<div
  class="card news-card"
  (click)="goToNewsDetail(); $event.stopPropagation()"
>
  <div class="news-card__img-container">
    <div class="news-card__overlay"></div>

    <img
      [ngClass]="{ hidden: isLoadingImage || hiddenImage }"
      (error)="hiddenImage = true; isLoadingImage = false"
      (load)="isLoadingImage = false"
      class="news-card__cover"
      src="{{ imageUrl }}"
    />

    <!-- Skeleton image start -->
    <div
      [medSkeletonLoading]="true"
      *ngIf="isLoadingImage"
      class="news-card__cover"
    ></div>
    <!-- Skeleton image end -->
  </div>

  <div class="news-card__title-header">
    <h2 class="news-card__title" title="{{ news?.content?.title }}">
      {{ news?.content?.title }}
    </h2>
    <small class="news-card__subtitle">
      {{ news?.content?.publishedAt | date : 'mediumDate' }}
    </small>
    <p class="news-card__excerpt">{{ news?.content?.excerpt }}</p>
  </div>

  <div class="news-card__content">
    <mec-tags-list [tags]="news?.tags"></mec-tags-list>
    <!-- Todo translate -->
    <button
      class="btn btn--sm"
      (click)="goToNewsDetail(); $event.stopPropagation()"
    >
      + {{ 'READ_MORE' | translate }}
    </button>
  </div>
</div>
